export default "__VITE_ASSET__DMM3x0QD__"